import { render } from "./TzPayWebMobile.vue?vue&type=template&id=8c0174e8&scoped=true"
import script from "./TzPayWebMobile.vue?vue&type=script&lang=js"
export * from "./TzPayWebMobile.vue?vue&type=script&lang=js"

import "./TzPayWebMobile.vue?vue&type=style&index=0&id=8c0174e8&lang=scss&scoped=true"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0174e8"]])

export default __exports__